import React from 'react'
import './section7.css'
import OrangeButton from '../../components/buttons/orangeButton'

export default function Section7({ handleDialogOpen }) {
    return (
        <div id="section7" className="container-fluid">
            <div className="container">
                <div className="row">
                    <div className="col-12 text-center mt-5 mb-5 pb-3">
                        <p className="titulo">Vamos começar?</p>
                        <p className="sub-titulo mt-4">
                            Pronto para elevar o nível{' '}
                            <span>tecnológico</span>{' '}
                            da sua empresa?
                        </p>
                        <p className="cta-desc mt-4">
                            Fale com a nossa equipe e descubra como podemos transformar seus desafios
                            em soluções eficientes, escaláveis e bem documentadas.
                        </p>
                        <div className="mt-5">
                            <OrangeButton onClick={() => handleDialogOpen()}>
                                Solicitar proposta
                            </OrangeButton>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
